var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"dense":"","filter":_vm.useStartsWith ? _vm.startsWithFilter : undefined,"outlined":""}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }